import React from 'react';

import { InfoCircleOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import classNames from 'classnames';

import browser from '@core/implementations/browser';

import styles from './SettingFormItem.module.scss';

type Props = {
  children: React.ReactNode;
  id?: string;
  label: string;
  tooltip?: string;
  url?: string;
  warning?: string;
};

function SettingFormItem({ children, id, label, tooltip, url, warning }: Props): React.JSX.Element {
  const renderInfo = (): React.ReactNode => {
    if (url) {
      return <InfoCircleOutlined className={classNames(styles.icon, styles.link)} onClick={() => browser.open(url)} />;
    }

    if (tooltip) {
      return (
        <Tooltip title={tooltip}>
          <QuestionCircleOutlined className={styles.icon} />
        </Tooltip>
      );
    }

    return null;
  };

  return (
    <div className={styles['setting-row']} id={id}>
      <div className={styles['label-container']}>
        <span className={styles.label}>{label}</span>
        {renderInfo()}
      </div>
      <div className={styles['control-container']}>
        {children}
        {warning && <img alt="warning" className={styles.warning} src="core-img/warning.svg" title={warning} />}
      </div>
    </div>
  );
}

export default SettingFormItem;
